// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r1R0","label":"styles_label__2y6K8"};